/** 购物车/订单行：名称列展示（产品名 + SKU 首段型号） */
export function cartDisplayName(row) {
  if (!row) return ''
  return String(row.display_goods_name || row.goods_name || '').trim()
}
